/**
 * Site Data Renderer
 * Renders site metadata, navigation, and other global content
 */

import type { SiteData } from '../../types';

export function renderSiteData(data: SiteData | null): void {
  if (!data) return;

  // Update navigation and section titles
  if (data.navigation) {
    const navList = document.querySelector<HTMLElement>('.nav__list');
    if (navList) {
      navList.innerHTML = data.navigation.map(item => `
        <li><a href="${item.anchor}" class="nav__link">${item.label}</a></li>
      `).join('');
    }

    // Update section titles
    data.navigation.forEach(item => {
      if (item.sectionTitleId) {
        const sectionTitle = document.getElementById(item.sectionTitleId);
        if (sectionTitle) {
          sectionTitle.textContent = item.label;
        }
      }
    });
  }

  // Update meta description
  if (data.meta?.beschreibung) {
    const metaDesc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', data.meta.beschreibung);
    }
  }

  // Update hero intro text
  if (data.einfuehrungstext) {
    const heroIntro = document.querySelector<HTMLElement>('.hero__intro-text');
    if (heroIntro) {
      heroIntro.innerHTML = data.einfuehrungstext.replace(/\n/g, '<br>');
    }
  }

  // Update map section title
  if (data.karte?.titel) {
    const mapTitle = document.getElementById('map-title');
    if (mapTitle) {
      mapTitle.textContent = data.karte.titel;
    }
  }

  // Update sponsors section title only (logos are defined in HTML)
  if (data.foerderer) {
    const sponsorsTitle = document.getElementById('sponsors-title');
    if (sponsorsTitle && data.foerderer.titel) {
      sponsorsTitle.textContent = data.foerderer.titel;
    }
  }
}
